export const REGIONAL_VEGETATION_TYPES: Record<number, {name: string, value: number}[]> = {
  1: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Sydney Blue Gum", value: 3 },
  { name: "Maritime Pine", value: 4 },
  { name: "Pinus Radiata", value: 5 }],
  2: [],
  3: [],
  4: [{ name: "Mixed species (Environmental Plantings)", value: 1 }],
  5: [{ name: "Mixed species (Environmental Plantings)", value: 1 }],
  6: [],
  7: [],
  8: [{ name: "Mixed species (Environmental Plantings)", value: 1 }],
  9: [],
  10: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Spotted Gum", value: 2 },
  { name: "Dunn's White Gum", value: 3 },
  { name: "Flooded Gum", value: 4 },
  { name: "Slash Pine", value: 5 },
  { name: "Loblolly Pine", value: 6 }],
  11: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Red Ironbark", value: 4 },
  { name: "Radiata Pine (low input)", value: 5 },
  { name: "Radiata Pine (high input)", value: 6 }],
  12: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Red Ironbark", value: 4 },
  { name: "Radiata Pine (low input)", value: 5 },
  { name: "Radiata Pine (high input)", value: 6 }],
  13: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Red Ironbark", value: 4 },
  { name: "Radiata Pine (low input)", value: 5 },
  { name: "Radiata Pine (high input)", value: 6 }],
  14: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Red Ironbark", value: 4 },
  { name: "Radiata Pine (low input)", value: 5 },
  { name: "Radiata Pine (high input)", value: 6 }],
  15: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Red Ironbark", value: 4 },
  { name: "Radiata Pine (low input)", value: 5 },
  { name: "Radiata Pine (high input)", value: 6 }],
  16: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Red Ironbark", value: 4 },
  { name: "Radiata Pine (low input)", value: 5 },
  { name: "Radiata Pine (high input)", value: 6 }],
  17: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Shining Gum", value: 3 },
  { name: "Radiata Pine (low input)", value: 4 },
  { name: "Radiata Pine (high input)", value: 5 }],
  18: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Shining Gum", value: 3 },
  { name: "Radiata Pine (low input)", value: 4 },
  { name: "Radiata Pine (high input)", value: 5 }],
  19: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Shining Gum", value: 3 },
  { name: "Radiata Pine (low input)", value: 4 },
  { name: "Radiata Pine (high input)", value: 5 }],
  20: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Shining Gum", value: 3 },
  { name: "Radiata Pine (low input)", value: 4 },
  { name: "Radiata Pine (high input)", value: 5 }],
  21: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Shining Gum", value: 3 },
  { name: "Radiata Pine (low input)", value: 4 },
  { name: "Radiata Pine (high input)", value: 5 }],
  22: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Shining Gum", value: 3 },
  { name: "Radiata Pine (low input)", value: 4 },
  { name: "Radiata Pine (high input)", value: 5 }],
  23: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Pinus Radiata", value: 3 }],
  24: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Pinus Radiata", value: 3 }],
  25: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Pinus Radiata", value: 3 }],
  26: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Pinus Radiata", value: 3 }],
  27: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Pinus Radiata", value: 3 }],
  28: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Shining Gum", value: 4 },
  { name: "Pinus Radiata (low input)", value: 5 },
  { name: "Pinus Radiata (high input)", value: 6 }],
  29: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Shining Gum", value: 4 },
  { name: "Pinus Radiata (low input)", value: 5 },
  { name: "Pinus Radiata (high input)", value: 6 }],
  30: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Shining Gum", value: 4 },
  { name: "Pinus Radiata", value: 5 }],
  31: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Shining Gum", value: 4 },
  { name: "Pinus Radiata", value: 5 }],
  32: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Shining Gum", value: 3 },
  { name: "Pinus Radiata", value: 4 }],
  33: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Tasmanian Blue Gum", value: 2 },
  { name: "Shining Gum", value: 3 },
  { name: "Mountain Ash", value: 4 },
  { name: "Pinus Radiata", value: 5 }],
  34: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Shining Gum", value: 4 },
  { name: "Pinus Radiata", value: 5 }],
  35: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Sugar Gum", value: 2 },
  { name: "Tasmanian Blue Gum", value: 3 },
  { name: "Shining Gum", value: 4 },
  { name: "Pinus Radiata", value: 5 }],
  36: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Hoop Pine", value: 2 },
  { name: "Lemon-scented Gum", value: 3 },
  { name: "Western White Gum", value: 4 },
  { name: "Blackbutt", value: 5 },
  { name: "Pinus Hybrids", value: 6 }],
  37: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Hoop Pine", value: 2 },
  { name: "Lemon-scented Gum", value: 3 },
  { name: "Western White Gum", value: 4 },
  { name: "Blackbutt", value: 5 },
  { name: "Pinus Hybrids", value: 6 }],
  38: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Hoop Pine", value: 2 },
  { name: "Lemon-scented Gum", value: 3 },
  { name: "Western White Gum", value: 4 },
  { name: "Blackbutt", value: 5 },
  { name: "Pinus Hybrids", value: 6 }],
  39: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Hoop Pine", value: 2 },
  { name: "Lemon-scented Gum", value: 3 },
  { name: "Western White Gum", value: 4 },
  { name: "Blackbutt", value: 5 },
  { name: "Pinus Hybrids", value: 6 }],
  40: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Hoop Pine", value: 2 },
  { name: "Lemon-scented Gum", value: 3 },
  { name: "Western White Gum", value: 4 },
  { name: "Blackbutt", value: 5 },
  { name: "Pinus Hybrids", value: 6 }],
  41: [{ name: "Mixed species (Environmental Plantings)", value: 1 },
  { name: "Hoop Pine", value: 2 },
  { name: "Lemon-scented Gum", value: 3 },
  { name: "Western White Gum", value: 4 },
  { name: "Blackbutt", value: 5 },
  { name: "Pinus Hybrids", value: 6 }],
  42: [{ name: "Mixed species (Environmental Plantings)", value: 1 }],
  43: [{ name: "Mixed species (Environmental Plantings)", value: 1 }],
  44: [{ name: "Mixed species (Environmental Plantings)", value: 1 }],
  45: [{ name: "Mixed species (Environmental Plantings)", value: 1 }]
  }

export const REGIONAL_SOIL_TYPES: Record<number, {name: string, value: number}[]> = {
  1: [{ name: "Loams & Clays", value: 1 },
  { name: "Sandy Duplexes", value: 2 }],
  2: [],
  3: [],
  4: [{ name: "Coloured Sands", value: 1 },
  { name: "Loams & Clays", value: 2 }],
  5: [{ name: "Loams & Clays", value: 1 },
  { name: "Sandy Duplexes", value: 2 }],
  6: [],
  7: [],
  8: [{ name: "Coloured Sands", value: 1 },
  { name: "Loams & Clays", value: 2 }],
  9: [],
  10: [{ name: "Duplex", value: 1 },
  { name: "Clay & Red Loam", value: 2 }],
  11: [{ name: "Clay", value: 1 },
  { name: "Loam", value: 2 }],
  12: [{ name: "Clay", value: 1 },
  { name: "Loam", value: 2 }],
  13: [{ name: "Clay", value: 1 },
  { name: "Loam", value: 2 }],
  14: [{ name: "Clay", value: 1 },
  { name: "Loam", value: 2 }],
  15: [{ name: "Clay", value: 1 },
  { name: "Loam", value: 2 }],
  16: [{ name: "Clay", value: 1 },
  { name: "Loam", value: 2 }],
  17: [{ name: "Other Soils", value: 1 },
  { name: "Structured Earths", value: 2 }],
  18: [{ name: "Other Soils", value: 1 },
  { name: "Structured Earths", value: 2 }],
  19: [{ name: "Other Soils", value: 1 },
  { name: "Structured Earths", value: 2 }],
  20: [{ name: "Other Soils", value: 1 },
  { name: "Structured Earths", value: 2 }],
  21: [{ name: "Other Soils", value: 1 },
  { name: "Structured Earths", value: 2 }],
  22: [{ name: "Other Soils", value: 1 },
  { name: "Structured Earths", value: 2 }],
  23: [{ name: "Duplex Soils", value: 1 },
  { name: "Cracking Clays", value: 2 }],
  24: [{ name: "Duplex Soils", value: 1 },
  { name: "Cracking Clays", value: 2 }],
  25: [{ name: "Sandy Soils", value: 1 },
  { name: "Loamy Soils", value: 2 }],
  26: [{ name: "Sandy Soils", value: 1 },
  { name: "Cracking Clays", value: 2 }],
  27: [{ name: "Sandy Soils", value: 1 },
  { name: "Loamy Soils", value: 2 }],
  28: [{ name: "Calcarosols", value: 1 },
  { name: "Yellow Duplex", value: 2 }],
  29: [{ name: "Calcarosols", value: 1 },
  { name: "Yellow Duplex", value: 2 }],
  30: [{ name: "Grey Cracking Clays", value: 1 },
  { name: "Red Duplex", value: 2 }],
  31: [{ name: "Grey Cracking Clays", value: 1 },
  { name: "Red Duplex", value: 2 }],
  32: [{ name: "Red Earths", value: 1 },
  { name: "Yellow Duplex", value: 2 }],
  33: [{ name: "Non-cracking Clays", value: 1 },
  { name: "Gradational soils", value: 2 }],
  34: [{ name: "Red Duplex", value: 1 },
  { name: "Yellow Duplex", value: 2 }],
  35: [{ name: "Cracking Clays", value: 1 },
  { name: "Red Duplex", value: 2 }],
  36: [{ name: "Clays", value: 1 },
  { name: "Duplex", value: 2 }],
  37: [{ name: "Clay Gidgee", value: 1 },
  { name: "Open Downs", value: 2 }],
  38: [{ name: "Clay Gidgee", value: 1 },
  { name: "Open Downs", value: 2 }],
  39: [{ name: "Clay", value: 1 },
  { name: "Gradational soils", value: 2 }],
  40: [{ name: "Clay (Brigalo and Belah)", value: 1 },
  { name: "Duplex Woodland", value: 2 }],
  41: [{ name: "Duplex", value: 1 },
  { name: "Earths", value: 2 }],
  42: [{ name: "Kandosols", value: 1 },
  { name: "Tenosols", value: 2 }],
  43: [{ name: "Kandosols", value: 1 },
  { name: "Tenosols", value: 2 }],
  44: [{ name: "Kandosols", value: 1 },
  { name: "Tenosols", value: 2 }],
  45: [{ name: "Kandosols", value: 1 },
  { name: "Tenosols", value: 2 }],
}

export const TRADING_REGION_EMISSIONS_FACTOR = [
  {
    "originCode": 2,
    "origin": "QLD - Northern",
    "emissionsFactor": 12.4
  },
  {
    "originCode": 4,
    "origin": "QLD - Central",
    "emissionsFactor": 12.4
  },
  {
    "originCode": 3,
    "origin": "QLD - Southern",
    "emissionsFactor": 12.4
  },
  {
    "originCode": 5,
    "origin": "NSW - Northern",
    "emissionsFactor": 11.7
  },
  {
    "originCode": 6,
    "origin": "NSW - Southern",
    "emissionsFactor": 11.7
  },
  {
    "originCode": 9,
    "origin": "NSW - Pastoral",
    "emissionsFactor": 12.4
  },
  {
    "originCode": 7,
    "origin": "VIC",
    "emissionsFactor": 11.7
  },
  {
    "originCode": 8,
    "origin": "SA - South West",
    "emissionsFactor": 11.7
  },
  {
    "originCode": 10,
    "origin": "SA - Pastoral",
    "emissionsFactor": 12.4
  },
  {
    "originCode": 12,
    "origin": "WA - Pastoral",
    "emissionsFactor": 12.4
  },
  {
    "originCode": 11,
    "origin": "WA - South West",
    "emissionsFactor": 11.7
  },
  {
    "originCode": 1,
    "origin": "NT",
    "emissionsFactor": 12.4
  },
  {
    "originCode": 13,
    "origin": "TAS",
    "emissionsFactor": 11.7
  },
  {
    "originCode": 14,
    "origin": "NZ",
    "emissionsFactor": 11.7
  },
  {
    "originCode": 15,
    "origin": "Dairy origin",
    "emissionsFactor": 4.4
  }
]
